import { render } from "./infoscreen-messages.vue?vue&type=template&id=dcb06d7a"
import script from "./infoscreen-messages.vue?vue&type=script&lang=js"
export * from "./infoscreen-messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__